import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a41a4c36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "player-detail-wrapper" }
const _hoisted_2 = { class: "layout-inner -top-and-bottom" }
const _hoisted_3 = { class: "player-detail-content" }
const _hoisted_4 = { class: "return" }
const _hoisted_5 = {
  key: 0,
  class: "player-detail-form"
}
const _hoisted_6 = { class: "global-unit" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "global-label"
}, "氏名", -1))
const _hoisted_8 = { class: "global-unit" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "global-label" }, "所属チーム", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseBreadcrumb = _resolveComponent("BaseBreadcrumb")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseBreadcrumb, { breadcrumbs: _ctx.breadcrumbs }, null, 8, ["breadcrumbs"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
            class: "global-return-link"
          }, "エントリーチームに戻る")
        ]),
        (_ctx.player.data != undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.player.data.name) = $event)),
                  type: "text",
                  id: "name",
                  readonly: "",
                  class: "global-input -large"
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.player.data.name,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_router_link, {
                  to: { name: 'teamDetail', params: { team_id: parseInt(_ctx.player.data.team_id) } },
                  class: "link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.player.data.team_name), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}